import { render, staticRenderFns } from "./examination_room_details.vue?vue&type=template&id=070d0ffc&scoped=true"
import script from "./examination_room_details.vue?vue&type=script&lang=js"
export * from "./examination_room_details.vue?vue&type=script&lang=js"
import style0 from "./examination_room_details.vue?vue&type=style&index=0&id=070d0ffc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070d0ffc",
  null
  
)

export default component.exports